module.exports = __webpack_public_path__ + "static/media/share.2246e3e9.png";